define([], () => {
    function daysInMonth(year, month) {
        return new Date(year, month + 1, 0).getDate();
    }

    return {
        daysInMonth: daysInMonth,
        daysInLocalDate: ld => daysInMonth(ld.year, ld.month),
        toMidnightDate: localDate => localDate ? new Date(localDate.year, localDate.month, localDate.day) : null,
        toLocalDate: date => ({ day: date.getDate(), month: date.getMonth(),year: date.getFullYear() }),
    };


});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/util/LocalDateUtil.js